// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.testimonials_main {
  display: flex;
  justify-content: center;
  margin-top: 50px;
}
.testimonials {
  width: 90%;
  /* display: flex; */
  /* justify-content: center; */
}

/* Desktop styles */
.testimonals_heading h2 {
  font-size: 58px;
  font-weight: 700;
  color: #141414;
  font-family: "Poppins", sans-serif !important;
}
.testimonals_para {
  color: #848484;
  font-size: 24px;
  font-family: "Poppins", sans-serif !important;
  font-weight: 400;
}
.testimonals_btn {
  margin-right: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 15px 40px;
  border: 2px solid #e837ff !important;
  color: #7511d3;
  letter-spacing: 1.25px;
  background: transparent;
  font-size: 14px;
  font-weight: 600;
  font-family: "Poppins", sans-serif !important;
}

/* Media Query for mobile devices */
@media (max-width: 768px) {
  .testimonals_btn {
    padding: 10px 30px;
    font-size: 14px;
    margin: 10px 0; /* Adjust margin for better spacing */
    width: auto; /* Auto width for better control */
    border: none; /* Optional: Remove border if it seems too bold on mobile */
  }
  .slick-next {
    margin-right: 10px;
  }
  .slick-prev{
    margin-left: 10px;
  }
}

.slick-slide > div {
  margin:0px 5px;
}

.testimonials .slick-prev:before,
.testimonials .slick-next:before {
  color: #9E54E3;
}

/* Optional styles for arrow buttons (e.g., background, border) */
.testimonials .slick-prev,
.testimonials .slick-next {
  background: transparent; /* Example: removing any background */
  border: none; /* Example: removing borders */
}

.testimonals_carousel_main {
  padding: 20px;
  margin: 20px 0px;
  background-color: #f8f8f8;
  border-radius: 16px;
  border: 2px solid #e1e4ea;
  box-shadow: 0px 18px 40px 0px #4a4a4a0a;
}

.testimonals_carousel_main_top {
  display: flex;
  gap: 20px;
  justify-content: space-between;
}

.testimonals_carousel_main_top_left {
  display: flex;
}

.testimonals_carousel_main_top_left_img img {
  margin-right: 20px;
  border-radius: 100%;
}

.testimonals_carousel_main_top_left_details h2 {
font-family: Sora;
font-size: 20px;
font-weight: 600;
line-height: 28px;
letter-spacing: 0.15000000596046448px;
text-align: left;
color: #0E121B;

}

.testimonals_carousel_main_top_left_details h3 {
font-family: Inter;
font-size: 14px;
font-weight: 400;
line-height: 24px;
text-align: left;

  color: #717784;
}

testimonals_carousel_main_top_right {
  align-items: flex-end;
}

.testimonals_carousel_main_top_right h4 {
  font-size: 12px;
  font-weight: 400;
  color: #91919c;
  font-family: "Poppins", sans-serif !important;
}


.testimonals_carousel_main_bottom {
font-family: Inter;
font-size: 16px;
font-weight: 400;
margin-bottom: 20px;
line-height: 26px;
text-align: left;

}

`, "",{"version":3,"sources":["webpack://./src/Testimonials/testimonials.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,cAAc;EACd,eAAe;EACf,6CAA6C;EAC7C,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;EACd,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA,mCAAmC;AACnC;EACE;IACE,kBAAkB;IAClB,eAAe;IACf,cAAc,EAAE,qCAAqC;IACrD,WAAW,EAAE,kCAAkC;IAC/C,YAAY,EAAE,2DAA2D;EAC3E;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA,iEAAiE;AACjE;;EAEE,uBAAuB,EAAE,qCAAqC;EAC9D,YAAY,EAAE,8BAA8B;AAC9C;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;AACA,iBAAiB;AACjB,eAAe;AACf,gBAAgB;AAChB,iBAAiB;AACjB,qCAAqC;AACrC,gBAAgB;AAChB,cAAc;;AAEd;;AAEA;AACA,kBAAkB;AAClB,eAAe;AACf,gBAAgB;AAChB,iBAAiB;AACjB,gBAAgB;;EAEd,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,6CAA6C;AAC/C;;;AAGA;AACA,kBAAkB;AAClB,eAAe;AACf,gBAAgB;AAChB,mBAAmB;AACnB,iBAAiB;AACjB,gBAAgB;;AAEhB","sourcesContent":[".testimonials_main {\n  display: flex;\n  justify-content: center;\n  margin-top: 50px;\n}\n.testimonials {\n  width: 90%;\n  /* display: flex; */\n  /* justify-content: center; */\n}\n\n/* Desktop styles */\n.testimonals_heading h2 {\n  font-size: 58px;\n  font-weight: 700;\n  color: #141414;\n  font-family: \"Poppins\", sans-serif !important;\n}\n.testimonals_para {\n  color: #848484;\n  font-size: 24px;\n  font-family: \"Poppins\", sans-serif !important;\n  font-weight: 400;\n}\n.testimonals_btn {\n  margin-right: 20px;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  padding: 15px 40px;\n  border: 2px solid #e837ff !important;\n  color: #7511d3;\n  letter-spacing: 1.25px;\n  background: transparent;\n  font-size: 14px;\n  font-weight: 600;\n  font-family: \"Poppins\", sans-serif !important;\n}\n\n/* Media Query for mobile devices */\n@media (max-width: 768px) {\n  .testimonals_btn {\n    padding: 10px 30px;\n    font-size: 14px;\n    margin: 10px 0; /* Adjust margin for better spacing */\n    width: auto; /* Auto width for better control */\n    border: none; /* Optional: Remove border if it seems too bold on mobile */\n  }\n  .slick-next {\n    margin-right: 10px;\n  }\n  .slick-prev{\n    margin-left: 10px;\n  }\n}\n\n.slick-slide > div {\n  margin:0px 5px;\n}\n\n.testimonials .slick-prev:before,\n.testimonials .slick-next:before {\n  color: #9E54E3;\n}\n\n/* Optional styles for arrow buttons (e.g., background, border) */\n.testimonials .slick-prev,\n.testimonials .slick-next {\n  background: transparent; /* Example: removing any background */\n  border: none; /* Example: removing borders */\n}\n\n.testimonals_carousel_main {\n  padding: 20px;\n  margin: 20px 0px;\n  background-color: #f8f8f8;\n  border-radius: 16px;\n  border: 2px solid #e1e4ea;\n  box-shadow: 0px 18px 40px 0px #4a4a4a0a;\n}\n\n.testimonals_carousel_main_top {\n  display: flex;\n  gap: 20px;\n  justify-content: space-between;\n}\n\n.testimonals_carousel_main_top_left {\n  display: flex;\n}\n\n.testimonals_carousel_main_top_left_img img {\n  margin-right: 20px;\n  border-radius: 100%;\n}\n\n.testimonals_carousel_main_top_left_details h2 {\nfont-family: Sora;\nfont-size: 20px;\nfont-weight: 600;\nline-height: 28px;\nletter-spacing: 0.15000000596046448px;\ntext-align: left;\ncolor: #0E121B;\n\n}\n\n.testimonals_carousel_main_top_left_details h3 {\nfont-family: Inter;\nfont-size: 14px;\nfont-weight: 400;\nline-height: 24px;\ntext-align: left;\n\n  color: #717784;\n}\n\ntestimonals_carousel_main_top_right {\n  align-items: flex-end;\n}\n\n.testimonals_carousel_main_top_right h4 {\n  font-size: 12px;\n  font-weight: 400;\n  color: #91919c;\n  font-family: \"Poppins\", sans-serif !important;\n}\n\n\n.testimonals_carousel_main_bottom {\nfont-family: Inter;\nfont-size: 16px;\nfont-weight: 400;\nmargin-bottom: 20px;\nline-height: 26px;\ntext-align: left;\n\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
